// APES
export const WANDERLIST_FAVORITES = "apes_apes2174-wanderlist-favorites";

// SUMO
export const HOME_TOUCHPOINTS_REDIRECTIONS = "FSC_SUMO4948";

// ACME
export const HSA_SIGNOUT_RELOAD = "acme_acme2208-signout-reload-v1";

// DPT
export const HSA_RESULTS_MOBILE_LAYOUT_V2 = "dpt_dpt6823";

// KEEPERS
export const USER_VERIFICATION_MODAL = "PRIME_KEEP2886";

export const FEATURE_ALIASES = {
  HOME_TOUCHPOINTS_REDIRECTIONS,
  WANDERLIST_FAVORITES,
  HSA_RESULTS_MOBILE_LAYOUT_V2,
  USER_VERIFICATION_MODAL,
};
